<div class="modal-header">
    <h4 class="modal-title font-weight-bold">{{ 'RESPOND-MODAL.HEADER' | translate }}{{message.sender}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">

    <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>

    <form *ngIf="respondForm" [formGroup]="respondForm" novalidate (ngSubmit)="respond(respondForm.value)">
        <div class="form-group">
            <label for="objet">{{ "CREATE.FORM.SUBJECT" | translate }} :</label>
            <input type="text" class="form-control" placeholder="{{ 'CREATE.FORM.SUBJECT' | translate }}" formControlName="objet" id="objet">
        </div>

        <div class="form-group mt-2">
            <editor id="content" [init]="{
                base_url: '/tinymce',
                suffix: '.min',
                height: 200,
                menubar: false,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                ],
                toolbar:
                'undo redo | formatselect | bold italic backcolor | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat'
            }" formControlName="content">
            </editor>
            <mat-error *ngIf="hasError('content', 'required')">{{ "ERRORS.CONTENT-REQUIRED" | translate }}</mat-error>
        </div>

        <div class="form-group mt-2">
            <div>
                <label for="attachments" class="btn btn-secondary">{{ "BUTTONS.ADD-FILE" | translate }}</label>
                <input type="file" #fileInput multiple="multiple" style="visibility: hidden;"
                   accept=".txt, .pdf, .docx, .doc, .csv, .xls, .xlsx, .doc, .jpg, .png, .jpeg, .gif, .bmp, image/*"
                   (change)="addAttachments(fileInput)" id="attachments" formControlName="attachments">
            </div>
            <ul>
                <li *ngFor="let attachment of this.attachmentsArray; let index = index">
                    <span>{{ attachment.name }}</span>
                    <em class="bi bi-x-circle-fill mx-2" style="color: red" (click)="removeAttachment(index)"></em>
                </li>
            </ul>
            <label for="progressBar">{{ "CREATE.FORM.SIZE" | translate }}</label>
            <div class="progress">
                <div id="progress-bar" class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;">
                    0%
                </div>
            </div>
        </div>

        <div class="from-group mt-2">
            <button type="submit" class="btn btn-primary mt-1" [disabled]="!respondForm.valid">{{ "BUTTONS.RESPOND" | translate }}</button>
        </div>
    </form>
</div>